import {useState, useEffect, useRef, useContext} from 'react';

import {USERS_API_BASE_URL} from '../../constants';
import AuthContext from "../../store/auth-context";
import { getUser } from '../../services/notification.services';
import button from '../Style/ButtonStyle.module.css';
import ChangePassword from './ChangePassword';
import UploadProfile from './UploadProfile';
const MyAccount = (props) => {
   
    const authCtx = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(true);
    const [userDetail,setUserDetail] = useState<any>(null)
    const [isRecipientModalOpen, setIsRecipientModalOpen] = useState(false);
    const [isRecipientModalOpenProfile, setIsRecipientModalOpenProfile] = useState(false);
    const [message, setMessage] = useState('');
    const [profileImg, setProfileImg] = useState('');
    console.log('detail',authCtx)

    const recipientModalHendler = () => {

        setIsRecipientModalOpen((prevState) => !prevState);
    }
    const recipientModalHendlerProfile = () => {
        setIsRecipientModalOpenProfile((prevState) => !prevState);
    }
    
    // Add callback to update profile image after upload
    const handleProfileImageUpdate = (newImageUrl) => {
        console.log('Profile image updated to:', newImageUrl);
        setProfileImg(newImageUrl);
    }
    useEffect(() => {
        // Use super-admin-token if impersonating, otherwise use current token
        const token = localStorage.getItem('super-admin-token') || authCtx.token;
        
        // Guard: check if userData exists
        if (!authCtx?.userData?.uuid) {
            setIsLoading(false);
            return;
        }

        getUser(authCtx.userData.uuid, token)
            .then((response) => {
                console.log('userRes',response)
                setIsLoading(false);
                setUserDetail(response);
                setProfileImg(response?.user?.thumbImage || '')
            })
            .catch((err) => {
                alert(err);
                console.error(err);
                setIsLoading(false);
            });
    }, [authCtx])
    
     console.log(userDetail)
    return (
        <div className="">
        {isRecipientModalOpen && <ChangePassword
            modalStatus={isRecipientModalOpen}
            onAction={recipientModalHendler}
            setMessage={setMessage}
            userDetail={userDetail}
        />}
        {isRecipientModalOpenProfile && <UploadProfile
            modalStatus={isRecipientModalOpenProfile}
            onAction={recipientModalHendlerProfile}
            setMessage={setMessage}
            userDetail={userDetail}
            setProfileImg={handleProfileImageUpdate}
        />}
        <div className="table-design">
        <div className='Modify_PageTitle__VS3pb FontFamily_fontMedium__1Bl7w' style={{"fontSize":14}}>{message}</div>
            
            {userDetail && 
                <div className="col-sm-12 p-2 ">
                <div className={button.divFlex}>
                    <p>{profileImg?<img src={profileImg} alt="Profile" style={{width: '80px', height: '80px', borderRadius: '50%'}} /> :<img className="userImg" src="/static/media/gray-user.e844667e.png"></img>}</p>
                    <div>
                        <p>{userDetail?.user?.firstName} {userDetail?.user?.lastName}</p>
                        <p>{userDetail?.user?.email}</p>
                        <p>{userDetail?.user?.phoneNumber}</p>
                        <button type="submit" onClick={recipientModalHendler} className={button.btn + ' ' + button.blueButton}>Change Password</button>
            <button type="submit" onClick={recipientModalHendlerProfile} className={button.btn + ' ' + button.blueButton + ' ' + button.buttonSpaceLeft}>Upload Profile Image</button>
                    </div>
                </div>
                </div>
            }
        </div>
        </div>
    )
}
export default MyAccount
